// Lion Auto: reading a failed call's body. Pure; LaMatchResults re-exports
// both for its callers.

// A 400's `details` is a list of "field: message" strings; objects and maps
// are read too so an older or newer server still shows something useful
export function detailLines(details) {
  if (!details) return [];
  if (typeof details === 'string') return [details];
  if (Array.isArray(details)) {
    return details.map(d => {
      if (typeof d === 'string') return d;
      if (d && typeof d === 'object') {
        if (d.message) return String(d.message);
        const where = d.field || d.path || d.key;
        const what = d.error || d.reason;
        if (where || what) return [where, what].filter(Boolean).join(': ');
      }
      return JSON.stringify(d);
    });
  }
  if (typeof details === 'object') {
    return Object.entries(details).map(([k, v]) => `${k}: ${typeof v === 'string' ? v : JSON.stringify(v)}`);
  }
  return [String(details)];
}

// Seconds a 429 asked us to wait (body field first, then the header)
export function retryAfterSec(err) {
  const body = Number(err?.response?.data?.retryAfter);
  const header = Number(err?.response?.headers?.['retry-after']);
  const secs = Number.isFinite(body) && body > 0 ? body : (Number.isFinite(header) && header > 0 ? header : 60);
  return Math.min(300, Math.max(1, Math.ceil(secs)));
}
